<template>
    <component :is="currentIcon" />
</template>
  
<script>
import CompanySvg from './svg/CompanySvg.vue'
import AdminPickupSvg from './svg/AdminPickupSvg.vue'
import MaterialsSvg from './svg/MaterialsSvg.vue'
import DeliveriesSvg from './svg/DeliveriesSvg.vue'
import RulesSvg from './svg/RulesSvg.vue'
import SupportSvg from './svg/SupportSvg.vue'
import PricingSvg from './svg/PricingSvg.vue'
import TicketRulesSvg from './svg/TicketRulesSvg.vue'
import TicketSvg from './svg/TicketSvg.vue'
import BillingSvg from './svg/BillingSvg.vue'
import CyberFormSvg from './svg/CyberFormSvg.vue'

export default {
  name: 'DynamicSvgIcon',
  props: ['svgTitle'],
  components: { CompanySvg, AdminPickupSvg, MaterialsSvg, DeliveriesSvg, RulesSvg, SupportSvg, PricingSvg, TicketRulesSvg, TicketSvg, BillingSvg, CyberFormSvg },
  computed: {
    currentIcon() {
      const icons = {
        CompanySvg: ['menu-companies', 'menu-marketplace', 'menu-company-details'], 
        AdminPickupSvg: ['menu-pickups'],
        MaterialsSvg: ['menu-materials'],
        DeliveriesSvg: ['menu-deliveries', 'menu-deliveries-create'],
        RulesSvg: ['menu-rules'],
        SupportSvg: ['menu-support', 'menu-support-info-freemium'],
        PricingSvg: ['menu-pricing', 'menu-pricing-tariff'],
        TicketRulesSvg: ['menu-rules-tickets'],
        TicketSvg: ['menu-tickets'],
        BillingSvg: ['menu-billing', 'menu-billing-details'],
        CyberFormSvg: ['menu-cyber-form']
      }
      const iconEntry = Object.entries(icons).find(([icon, aliases]) =>
        aliases.includes(this.svgTitle)
      )
      return iconEntry ? this.$options.components[iconEntry[0]] : null 
    }
  }
}
</script>